document.addEventListener('DOMContentLoaded', function() {
    const sliderTrack = document.querySelector('.sneaka-slider__track');
    const slides = Array.from(document.querySelectorAll('.sneaka-slider__slide'));
    const prevButton = document.querySelector('.sneaka-slider__button--prev');
    const nextButton = document.querySelector('.sneaka-slider__button--next');

    let currentSlide = 0;
    let slidesToShow = 3; // Default for desktop
    let totalSlides = slides.length;
    let slideWidth = slides[0].offsetWidth;

    // Duplicate the slides to create an infinite scroll effect
    slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        sliderTrack.appendChild(clone);
    });

    let allSlides = document.querySelectorAll('.sneaka-slider__slide'); // Update to include cloned slides
    totalSlides = allSlides.length; // Update total slide count

    // Set initial track position
    function updateSlider() {
        let offset = -(currentSlide * slideWidth);
        sliderTrack.style.transition = 'transform 0.5s ease';
        sliderTrack.style.transform = `translateX(${offset}px)`;

        // Handle seamless infinite loop
        if (currentSlide >= totalSlides / 2) {
            // When reaching the cloned slides, jump back to the original slides without animation
            setTimeout(() => {
                sliderTrack.style.transition = 'none';
                currentSlide = currentSlide % (totalSlides / 2); // Reset to the equivalent slide in the original set
                offset = -(currentSlide * slideWidth);
                sliderTrack.style.transform = `translateX(${offset}px)`;
            }, 500); // Wait for the transition to finish
        }
    }

    // Function to determine how many slides to show based on screen size
    function setSlidesToShow() {
        const viewportWidth = window.innerWidth;
        if (viewportWidth < 768) {
            slidesToShow = 1;  // Show 1 slide on mobile
        } else if (viewportWidth < 1024) {
            slidesToShow = 2;  // Show 2 slides on tablets
        } else {
            slidesToShow = 3;  // Show 3 slides on desktops
        }
        slideWidth = allSlides[0].offsetWidth;
        updateSlider();
    }

    // Handle clicking next button
    nextButton.addEventListener('click', function() {
        currentSlide++;
        updateSlider();
    });

    // Handle clicking previous button
    prevButton.addEventListener('click', function() {
        if (currentSlide > 0) {
            currentSlide--;
        } else {
            currentSlide = totalSlides / 2 - 1; // Jump to the last slide in the original set when going backward
        }
        updateSlider();
    });

    // Update slider on window resize
    window.addEventListener('resize', setSlidesToShow);

    // Initialize slider
    setSlidesToShow();
});
